const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})/;

export const parseDateOnly = (value: string | null | undefined): Date | null => {
  if (!value) {
    return null;
  }

  const match = value.trim().match(DATE_ONLY_PATTERN);
  if (!match) {
    return null;
  }

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const parsed = new Date(year, month - 1, day);

  if (
    parsed.getFullYear() !== year
    || parsed.getMonth() !== month - 1
    || parsed.getDate() !== day
  ) {
    return null;
  }

  return parsed;
};

export const formatDateOnly = (value: Date): string => {
  const year = value.getFullYear();
  const month = String(value.getMonth() + 1).padStart(2, '0');
  const day = String(value.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const startOfLocalDay = (value: Date): Date => (
  new Date(value.getFullYear(), value.getMonth(), value.getDate())
);

export const addBusinessDays = (from: Date, days: number): string => {
  const result = startOfLocalDay(from);
  let added = 0;

  while (added < days) {
    result.setDate(result.getDate() + 1);
    const dayOfWeek = result.getDay();
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      added += 1;
    }
  }

  return formatDateOnly(result);
};

export const resolveStandardDeliveryDate = (
  lastWorkoutDate: string | null | undefined,
  today: Date = new Date(),
): string => {
  const todayDay = startOfLocalDay(today);
  const fromToday = addBusinessDays(todayDay, 4);
  const lastWorkoutDay = parseDateOnly(lastWorkoutDate);
  if (!lastWorkoutDay) {
    return fromToday;
  }

  const fromLastWorkout = addBusinessDays(lastWorkoutDay, 4);
  return fromLastWorkout >= formatDateOnly(todayDay) ? fromLastWorkout : fromToday;
};
